import React from 'react';
import PropTypes from 'prop-types';
import { TagList } from '@fiverr/fit';
import './style.scss';

const Tags = ({title, tags}) => (
    <section className="seo tags">
        <h2>{i18n.t('seo_sub_category.tags.title', {sub_category_title: title})}</h2>
        <TagList tags={tags}/>
    </section>
);

Tags.propTypes = {
    tags: PropTypes.array
};

Tags.defaultProps = {
    tags: []
};

export default Tags;



// WEBPACK FOOTER //
// ./src/components/Tags/index.js